import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage } from '../../../utils/Errors'
import { idleAndStandByMapper } from '../../../components/CoreSettings/utils/IdleAndStandByMapper'
import { GeneralSettingsBackend, IGeneralSettings } from '../../../types/settings'
import { getUrlWithVersion } from '../../../api/api'

export const fetchProductGeneralSettings = createAsyncThunk<
    { guid: string; data: IGeneralSettings | GeneralSettingsBackend },
    { guid: string },
    ThunkConfig<string>
>('coreSettingsSlice/fetchProductGeneralSettings', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const { guid } = args
    try {
        const { data } = await api.get(
            getUrlWithVersion(`/products/${guid}/core_settings/general`)
        )

        let mappedData = idleAndStandByMapper(data)

        return { guid, data: mappedData }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to fetch core settings')
    }
})
